"use client";
import React, { useState } from "react";
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetFooter,
} from "@/components/ui/sheet";
import { Button } from "@/components/ui/button";
import {
  AdjustmentsHorizontalIcon,
  XMarkIcon,
} from "@heroicons/react/24/outline";
import FilterList from ".";

export default function MobileFilter({
  filterAttributes,
}: {
  filterAttributes: any;
}) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <div className="flex flex-wrap gap-3">
        <Button
          variant="secondary"
          className="flex bg-neutral-100 capitalize dark:bg-neutral-800"
          onClick={() => setIsOpen(true)}
        >
          <AdjustmentsHorizontalIcon className="h-6 w-8 fill-white stroke-black dark:stroke-white" />
          <span className="font-outfit text-base tracking-wide">Filter</span>
        </Button>
      </div>

      <Sheet open={isOpen} onOpenChange={setIsOpen}>
        <SheetContent side="left" className="w-full max-w-[400px]">
          <SheetHeader className="flex flex-row items-center justify-between">
            <SheetTitle>Product Filters</SheetTitle>
            <button
              className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md border border-neutral-200 text-black transition-colors dark:border-neutral-700 dark:text-white"
              onClick={() => setIsOpen(false)}
              aria-label="Close mobile menu"
            >
              <XMarkIcon className="h-6" />
            </button>
          </SheetHeader>
          <div className="py-4">
            <FilterList filterAttributes={filterAttributes} />
          </div>
          <SheetFooter />
        </SheetContent>
      </Sheet>
    </>
  );
}
